import { html } from "lit";
var icon_location_default = () => html`
  <svg stroke-fill viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
    <g stroke-width="2" fill="none" fill-rule="evenodd">
      <path
        d="M16 17.574c2.692 0 4.875-2.175 4.875-4.858S18.692 7.858 16 7.858s-4.875 2.175-4.875 4.858 2.183 4.858 4.875 4.858Z" />
      <path
        d="M16 3a9.767 9.767 0 0 1 6.894 2.846 9.699 9.699 0 0 1 2.856 6.87c0 4.327-6.337 12.73-8.794 15.822a1.22 1.22 0 0 1-1.913 0C12.588 25.444 6.25 17.043 6.25 12.716a9.699 9.699 0 0 1 2.856-6.87A9.767 9.767 0 0 1 16 3Z" />
    </g>
  </svg>
`;
export {
  icon_location_default as default
};
//# sourceMappingURL=icon-location.js.map
